import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const deliveryTypesAdapter = getAdapter({ idFieldName: 'value' });

const deliveryTypesSlice = createSlice({
  name: 'deliveryTypes',
  initialState: deliveryTypesAdapter.getInitialState(),
  reducers: {
    setDeliveryTypes: (state, { payload: { deliveryTypes } }) => {
      deliveryTypesAdapter.setAll(state, deliveryTypes);
    },
  },
});

const selectors = deliveryTypesAdapter.getSelectors(({ deliveryTypes }) => deliveryTypes);

export const getDeliveryTypes = (state) => selectors.selectAll(state);

export const {
  setDeliveryTypes,
} = deliveryTypesSlice.actions;

export default deliveryTypesSlice.reducer;
